import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=79c7c042&scoped=true"
import script from "./IconSvg.vue?vue&type=script&lang=ts"
export * from "./IconSvg.vue?vue&type=script&lang=ts"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=79c7c042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c7c042",
  null
  
)

export default component.exports